import React, { useState } from "react";
import { Layout, Menu, Breadcrumb, Avatar, Dropdown } from "antd";
import { useHistory } from "react-router";
import {
  PieChartOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserAddOutlined,
  BellOutlined,
  QuestionCircleOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { HeadIcons } from "../../Styles";
import fire from "../../fire";
import ApplyClaim from "./ApplyClaim/ApplyClaim";

export default function DashBoard() {
  const history = useHistory();
  const { Header, Content, Sider } = Layout;
  const [collapsed, setCollapsed] = useState(false);

  const onCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed);
  };

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const signOut = () => {
    fire
      .auth()
      .signOut()
      .then(() => {
        // Sign-out successful.
        history.push("/");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <a rel="noopener noreferrer" onClick={signOut}>
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Layout style={{ minHeight: "100vh" }}>
        <Sider theme="light" collapsed={collapsed} onCollapse={onCollapse}>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: toggle,
            }
          )}

          <Menu theme="light" defaultSelectedKeys={["1"]} mode="inline">
            <Menu.Item key="1" icon={<PieChartOutlined />}>
              Apply Claim
            </Menu.Item>
            <Menu.Item key="2" icon={<UserAddOutlined />}>
              Users
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }}>
            {" "}
            <div className="logo" />
            <HeadIcons>
              <QuestionCircleOutlined style={{ marginRight: "10px" }} />
              <BellOutlined style={{ marginRight: "10px" }} />
              <Avatar
                src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                style={{ marginRight: "10px" }}
              />
              <Dropdown overlay={menu}>
                <a
                  style={{ marginRight: "10px", color: "white" }}
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  Tedd Russel <DownOutlined />
                </a>
              </Dropdown>
            </HeadIcons>
          </Header>
          <Content style={{ margin: "0 16px" }}>
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>Apply Claim</Breadcrumb.Item>
            </Breadcrumb>
            <div
              className="site-layout-background"
              style={{ padding: 24, minHeight: 360 }}
            >
              <ApplyClaim />
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}
